import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { APIServiceService } from 'src/app/api/apiservice.service';
import { Appointment } from 'src/app/models/appointment.model';
import { Customer } from 'src/app/models/customer.model';
import { Rider } from 'src/app/models/rider.model';
import { NotificationsService } from 'src/app/services/notifications.service';

@Component({
  selector: 'ubc-rider-edit-form',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './rider-edit-form.component.html',
  styleUrl: './rider-edit-form.component.scss'
})
export class RiderEditFormComponent {

  @Input() rider?: Rider
    riderForm: FormGroup
    @Output() cleared: EventEmitter<void> = new EventEmitter()
    @Output() riderCreated: EventEmitter<Rider> = new EventEmitter()
  
    constructor(
      private notificationsService: NotificationsService,
      private apiService: APIServiceService
    ){
      this.riderForm = new FormGroup({
        id: new FormControl(0),
        name: new FormControl('', Validators.required)
      })
    }
  
    ngOnInit(){
      this.populateRiderForm()
    }
  
    populateRiderForm(){
      const riderData =  this.rider  || { id: undefined, name: undefined }
      this.riderForm.patchValue(riderData)
  
      console.log(this.riderForm.value)
    }
  
    async customerFormSubmit(){
  
      try {
      if(this.riderForm.value.id){
        // const updated = await this.apiService.customer.update(this.riderForm.value)
        // this.notificationsService.add("success", "Customer Details Updated", `${this.riderForm.value.firstName} ${this.riderForm.value.lastName} details were sucessfully updated`)
      } else {
        const rider = new Rider(0, this.riderForm.value['name'], 0, 0)
        const created = await this.apiService.riders.create(rider)
        this.notificationsService.add("success", "Rider Created", `${rider.name}  was created`)
        const newRider = new Rider(created.data.id, created.data.name, created.data.weightKg, created.data.heightCm)
        this.riderCreated.emit(newRider)
      }
      } catch(e){
        throw e
      }
    }
  
    changeCustomerClicked(){
      console.log("Click")
      this.cleared.emit()
    }

}
